"use client";

import { useTitleStore } from '../../stores';

const MenuTitle = () => {
    const { selectedTitle } = useTitleStore();

    return (
        <div 
            className="
                bg-gradient-to-r from-[#094689] to-[#1e84f6]
                h-[180px]      // 기본 높이, 가장 작은 화면에서 적용
                xs:h-[300px]   // 320px 이상 화면 크기에서 적용
                sm:h-[320px]   // 640px 이상 화면 크기에서 적용
                md:h-[340px]   // 768px 이상 화면 크기에서 적용
                lg:h-[360px]   // 1024px 이상 화면 크기에서 적용
                xl:h-[380px]   // 1280px 이상 화면 크기에서 적용
                2xl:h-[400px]  // 1536px 이상 화면 크기에서 적용
                flex items-center justify-center text-white px-4 py-6 relative
            "
        >
            <div 
                className="
                    text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold
                    absolute
                    lg:left-[380px] lg:transform-none lg:-translate-x-0
                    left-1/2 transform -translate-x-1/2
                    top-1/2 -translate-y-1/2
                    whitespace-nowrap  // 텍스트 줄바꿈 방지
                "
            >
                {selectedTitle}
            </div>
        </div>
    );
};

export default MenuTitle;
